import styled from 'styled-components';
import { mediaQuery } from '../../common/styles/styleUtil';

export const DesktopAccountWrapper = styled.div`
  display: flex;
  align-items: center;
  a:not(.desktop-account-text) {
    margin-left: 16px;
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
  }

  a:hover,
  a:active {
    text-decoration-line: underline;
  }

  @media (${mediaQuery.tablet}) {
    display: none;
  }
`;

export const AccountTextWrapper = styled.a`
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  line-height: normal;
  color: #697684;
  &:hover {
    opacity: 1;

    .icon {
      text-decoration: none;
    }
  }

  .icon {
    transform: translateY(2px);
  }

  @media (${mediaQuery.tablet}) {
    display: none;
  }
`;

export const PopoverWrapper = styled.div`
  a {
    color: inherit;
    &.logout-btn {
      display: block;
      width: 186px;
      margin-top: 16px;
      color: #2b6ed2;
      background-color: #ffffff;
      border: 1px solid #2b6ed2;
      border-radius: 3px;
      padding: 8px 0;
      font-size: 12px;
      font-weight: 500;
      text-align: center;
    }
  }
`;

export const UserEmail = styled.p`
  max-width: 186px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #d8d8d8;
`;
